module.exports = __webpack_public_path__ + "static/media/Akia W.d91db627.png";